import { getUrlVars, validateEmail } from '../../utils/common';

export default class LeadForm {
    constructor(formEl) {
        this.form = formEl;
        this.id = this.form.dataset.id;

        this.formFields = [
            'name',
            'emailId',
            'phone',
            'countryCode',
            'seekerCity',
            'loanRequired',
            'propertyManagement'
        ];

        this.sending = false;
        this.btnSubmitEl = this.form.btnSubmit;
        
        this.attachEventListeners();
    }

    attachEventListeners() {
        let inputs = this.form.querySelectorAll('input[type="text"],input[type="number"]');
        let select = this.form.querySelector('select');

        inputs.forEach((input, i) => {
            input.addEventListener('keyup', () => {
                input.parentNode.classList.remove('error');
            });
        });
        
        select.addEventListener('change', () => select.parentNode.classList.remove('error'));
        
        // Submit Button
        this.form.addEventListener('submit', e => this.submit(e));
    }

    submit(e) {
        e.preventDefault();

        if(this.sending) {
            return false;
        }

        const inputs = this.getInputs();

        let validation = this.validate(inputs);

        if (validation !== true) {
            return false;
        }

        const payload = this.preparePayload(inputs);

        this.setFormState('disable');

        this.shareLead(payload).then((res) => {

            if (res && res.statusCode === 200 && res.message === "success") {
                dataLayer.push({'event':'form-submit-success','projectname':window.globals.scopeName});
                this.showSuccessMessage();
            } else {
                console.error(res);
                alert('Some error occurred. Please try again');
            }

            this.setFormState('enable');
        });
    }

    setFormState(state) {
        if(state === 'disable') {
            this.sending = true;
            this.btnSubmitEl.disabled = true;
            return;
        }

        this.sending = false;
        this.btnSubmitEl.disabled = false;
    }

    showSuccessMessage() {
        let formEl = document.getElementById('gp_lead_form' + this.id);
        let msgEl = document.getElementById('gp_form_msg' + this.id);

        formEl.classList.add('hide');
        msgEl.classList.remove('hide');
    }

    validate(payload) {
        let errorFields = [];

        this.clearErrors();

        for (let i in this.formFields) {

            if (payload[this.formFields[i]] === '') {
                errorFields.push(this.formFields[i]);
            }

            switch (this.formFields[i]) {
                case 'emailId':
                    if (!validateEmail(payload[this.formFields[i]])) {
                        errorFields.push(this.formFields[i])
                    }
                    break;
                case 'phone':
                    if (!this.validatePhone(payload.countryCode, payload.phone)) {
                        errorFields.push(this.formFields[i])
                    }
                    break;
                case 'name':
                case 'seekerCity':
                    if (!this.isAlpha(payload[this.formFields[i]])) {
                        errorFields.push(this.formFields[i]);
                    }
                    break;
            }

        }

        if (errorFields.length > 0) {
            for (let i in errorFields) {
                this.form[errorFields[i]].parentNode.classList.add('error')
            }

            return false;
        }

        return true;
    }

    isAlpha(value) {
        return /^[a-zA-Z\s.]+$/.test(value);
    }

    validatePhone(countryCode, phone) {
        if (phone.trim() == '') {
            return false;
        }

        return ('+91' !== countryCode) ? /^[0-9]{4,12}$/.test(phone) : /^[6789]\d{9}$/.test(phone);
    }

    clearErrors() {
        for (let i in this.formFields) {
            this.form[this.formFields[i]].parentNode.classList.remove('error');
        }
    }

    preparePayload(inputs) {
        return {
            'formData': JSON.stringify(inputs)
        }
    }

    getInputs() {
        let name = this.form.name.value.trim();
        let emailId = this.form.emailId.value.trim();
        let phone = this.form.phone.value.trim();
        let seekerCity = this.form.seekerCity.value.trim();
        let countryCode = this.form.countryCode.value;
        let country = this.form.countryCode.options[this.form.countryCode.selectedIndex].dataset.country;
        let loanRequired = this.form.loanRequired.checked ? 1 : 0;
        let propertyManagement = this.form.propertyManagement.checked ? 1 : 0;
        let utmResult = this.getUtmData();

        let payload = {
            'name': name,
            'emailId': emailId,
            'phone': phone,
            'countryCode': countryCode,
            'country': country,
            'seekerCity': seekerCity,
            'loanRequired': loanRequired,
            'propertyManagement': propertyManagement,
            'pageType': window.globals.pageType,
            'scopeName': window.globals.scopeName,
            'scope': window.globals.scope,
            'scopeId': window.globals.scopeId,
            'formId': window.globals.pageType + '_IAMINTERESTED',
            'utmParam': this.formatUtmData(utmResult)
        };

        return payload;
    }

    formatUtmData(utmResult) {
        if(utmResult['utm_campaign'] === 'none') {
            return '';
        }

        return `utm_source=${utmResult['utm_source']}&utm_campaign=${utmResult['utm_campaign']}&utm_medium=${utmResult['utm_medium']}`;
    }

    getUtmData() {
        let trafficSource = "none";
        let trafficMedium = "none";
        let trafficCamp = "none";
        let utmData = {};
        let paramObj = getUrlVars();

        trafficSource = paramObj['utm_source'] || trafficSource;
        trafficMedium = paramObj['utm_medium'] || trafficMedium;
        trafficCamp = paramObj['utm_campaign'] || trafficCamp;

        utmData['utm_source'] = trafficSource;
        utmData['utm_medium'] = trafficMedium;
        utmData['utm_campaign'] = trafficCamp;

        return utmData;
    }

    shareLead(data) {
        const url = '/homes/gruhapravesham/shareLead';
        return fetch(url, {
                method: "POST",
                body: this.makeFormData(data)
            })
            .then(response => response.json());
    }

    makeFormData(obj = {}) {
        let formData = new FormData();
        for (let key in obj) {
            formData.append(key, obj[key]);
        }
        return formData;
    }
}